import { useMemo, useState, useEffect } from 'react';
import propTypes from 'prop-types';
import {
  CssBaseline,
  ThemeProvider,
  Snackbar
} from '@mui/material';

import { lightTheme, darkTheme } from './theme';
import PublicRoutes from './routes/PublicRoutes';
import Navigation from './navigation/Navigation';
import Footer from './components/footer/Footer';

const getInitialMode = () => {
  const savedMode = localStorage.getItem('themeMode');
  if (savedMode) return savedMode;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export default function App({ callback }) {
  const [mode, setMode] = useState(getInitialMode);
  const theme = useMemo(() => (mode === 'light' ? lightTheme : darkTheme), [mode]);

  useEffect(() => {
    localStorage.setItem('themeMode', mode);
  }, [mode]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  useEffect(() => {
    callback.onUpdate = () => {
      console.log('service worker update waiting');
      setSnackbarMessage('A new version is available: exit the app to update');
      setSnackbarOpen(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navigation mode={mode} setMode={setMode}>
        <PublicRoutes />
        <Footer />
      </Navigation>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={60000}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
      />
    </ThemeProvider>
  );
}

App.propTypes = {
  callback: propTypes.object
};



